var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93329 0.385254C10.7478 0.385254 11.5314 0.773707 12.1078 1.47072C12.6848 2.16627 13.0073 3.10442 13.0073 4.08655V9.87669C13.0073 11.9216 11.6285 13.578 9.93329 13.578H3.93281C2.23756 13.578 0.859375 11.9216 0.859375 9.87669V4.08655C0.859375 2.04167 2.23149 0.385254 3.93281 0.385254H9.93329ZM10.8999 5.17874L10.9485 5.12011C11.0936 4.90756 11.0936 4.59973 10.9418 4.38718C10.8574 4.27797 10.7414 4.21127 10.6205 4.19661C10.4929 4.18855 10.3715 4.24059 10.2797 4.3432L7.54098 6.98175C7.18869 7.33429 6.68394 7.33429 6.32619 6.98175L3.5929 4.3432C3.404 4.17463 3.14281 4.19661 2.9855 4.39451C2.8215 4.5924 2.80328 4.90756 2.94237 5.12744L3.02194 5.22272L5.7856 7.82462C6.12574 8.14711 6.53817 8.32301 6.97003 8.32301C7.40067 8.32301 7.82038 8.14711 8.15992 7.82462L10.8999 5.17874Z",
    fill: "#3A974C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.eef4a8b0f33f021b127390e898522347.svg";
export { ForwardRef as ReactComponent };